<template>
    <div>

        <!-- Filter Start -->
        <div class="innerBox mb-4">
            <div class="row">
                <!-- <a class="navbar-brand ml-3">Cek Status Truk</a> -->
                <div class="col-md-9">
                    <input
                        class="form-control filterInput"
                        type="search"
                        placeholder="Masukkan Kode Dealer"
                        aria-label="Search"
                        style="font: normal normal normal 16px/25px Poppins;"
                        v-model="filter.search"
                    >
                </div>
                <div class="col-md-3 text-right">
                    <button
                        class="btn"
                        type="button"
                        style="background-color: #1B698E; color: white; padding: 0 50px; height: 100%; font-weight: bold; font: normal normal 600 14px/21px Poppins;"
                        @click="vue_universal_table.update++"
                    >CARI</button>
                </div>
            </div>
        </div>
        <!-- Filter End -->

        <div class="innerBox">
            <div class="mb-4 row">
                <div class="col-md-4"></div>
                <div class="col-md-2">
                    <h3 
                        class="tableTitle text-left"
                        style="font: normal normal normal 16px/25px Poppins;">Dealer Setting</h3>
                </div>
                <!-- <div class="col-md-2 text-right">
                    <button
                        class="btn border-secondary rounded shadow w-100"
                        type="button"
                        style="background-color: #1B698E; color: white; padding: 0 50px; height: 100%; font-weight: bold; font: normal normal normal 12px/18px Poppins;"
                        @click="modal.upload = true"
                    >Tambah</button>
                </div> -->
                <div class="col-md-2 text-right">
                    <button
                        class="btn rounded w-100"
                        type="button"
                        style="background-color: #CFECF9; font: normal normal normal 12px/18px Poppins;"
                        @click="modal.tambah = true"
                    >Tambah</button>
                </div>
                <div class="col-md-2 text-right">
                    <button
                        class="btn rounded w-100"
                        type="button"
                        style="background-color: #CFECF9; font: normal normal normal 12px/18px Poppins;"
                        @click="modal.upload = true"
                    >Upload File</button>
                </div>
                <div class="col-md-2 text-right">
                    <button
                        class="btn rounded w-100"
                        type="button"
                        style="background-color: #CFECF9; font: normal normal normal 12px/18px Poppins;"
                        @click="downloadDealer"
                    >Download XLSX</button>
                </div>
            </div>

            <!-- Table Start -->
            <vue-universal-table
                api_url="/api/settings/get-locations"
                :filter="filter"
                :fields="vue_universal_table.fields"
                :update="vue_universal_table.update"
                :buttons="vue_universal_table.buttons"
                :infinite_scroll="true"

                sort_order="DESC"
                sort_by="updated_at"
                style="font: normal normal normal 12px/18px Poppins;"

                @onViewDetails="openDealerStatusDetails"
            ></vue-universal-table>
            <!-- Table End -->

        </div>

        <!-- Modal Start -->
        <dealer-status-details
            v-if="modal.details"
            :data="modal.data"
            @refreshTable="vue_universal_table.update++"
            @closeModal="modal.details = false; modal.data = null"
        ></dealer-status-details>

        <DealerStatusUpload 
            v-if="modal.upload"
            @closeModal="modal.upload = false"
            @onFinish="vue_universal_table.update++"
        />

        <DealerStatusTambah 
            v-if="modal.tambah"
            :data="modal.data"
            @refreshTable="vue_universal_table.update++"
            @closeModal="modal.tambah = false; modal.data = null"
        />
        <!-- Modal End -->

    </div>
</template>

<script>
    import qs from 'qs'

    import dealerStatusDetails from './children/DealerStatusDetails'
    import DealerStatusUpload from './children/DealerStatusUpload.vue'
    import DealerStatusTambah from './children/DealerStatusTambah.vue'

    export default {
        metaInfo : {
            title : 'Dealer Status'
        },
        data () {
            return {
                modal: {
                    details: null,
                    data : {
                        dealer_name: null,
                        dealer_code : null,
                    },
                    upload : false,
                    tambah : null
                },
                filter : {
                    search : null
                },
                vue_universal_table : {
                    fields : [
                        {title:"Nama Dealer", variable:"dealer_name"},
                        {title:"Kode Dealer", variable:"dealer_code"},
                        {title:"Status Lokasi", variable:"location_status"},
                        {title:"Last Updated", variable:"updated_at"},
                    ],
                    buttons: [
                        {
                            title: 'viewDetails',
                            class: 'fas fa-pen btn-outline-primary'
                        },
                    ],
                    filter: {},
                    update : 0,
                    process_data : `
                        for (var i in data) {
                            data[i].dealer_code = data[i].dealer_code ? data[i].dealer_code : '-'
                            data[i].dealer_name = data[i].dealer_name ? data[i].dealer_name : '-'
                            data[i].location_status = data[i].location_status ? data[i].location_status : '-'
                            data[i].updated_at = data[i].updated_at ? data[i].updated_at : '-'
                        }
                    `
                },
            }
        },
        components: {
            dealerStatusDetails,
            DealerStatusUpload,
            DealerStatusTambah,
        },
        mounted () {

        },
        methods : {
            openDealerStatusTambah (data) {
                this.modal.data  = JSON.parse(data)
                this.modal.tambah = true;
            },
            openDealerStatusDetails (data) {
                this.modal.data  = JSON.parse(data)
                this.modal.details = true;
            },
            downloadDealer () {
                for (var i in this.filter) if (this.filter[i] == '') this.filter[i] = null

                this.$http.get(`/api/settings/get-locations?pagination=false&${qs.stringify(this.filter, {skipNulls:true, arrayFormat: 'comma'})}`)
                .then((resp)=>{
                    this.exportExcel(resp.data.data, "Dealer Location Download");
                })
                .catch((err)=>{console.log(err)});
            }
        }
    }
</script>

<style scoped>
    .innerBox {
        background-color: white;
        border-radius: 8px;
        box-shadow: 0px 3px 10px #0000000F;
        padding: 20px;

    }

    .chart {
        background-color: white;
        border-radius: 8px;
        box-shadow: 0px 3px 10px #0000000F;
        padding: 20px;
        align-items: center;
    }

    .elegant--sub-title {
        font-size: 18px;
        font-weight: 500;
        color: #9F9F9F;
    }

    .tableTitle {
        text-align: center;
    }

    /* .center {
        padding: 50px 20px;
        display: flexbox;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    } */

    .stats--icon {
        display:flex; 
        align-items:center; 
        justify-content:center;
        text-align: center;
    }

    .table td, .table th{
        text-align: center;
    }
</style>